import "./DesktopMonetizeHero.css";
import { useLang } from "../../../../i18n/LangContext";
import handshakeImage from "../../../../assets/desktopMonetize/hero/handshake.png";

export default function DesktopMonetizeHero({
  id = "join-us",
  imageSrc = handshakeImage,
  onPublisher = () => {},
  onAdvertiser = () => {},
}) {
  const { t } = useLang();
  const data = t?.monetizeHero;
  if (!data) return null;

  return (
    <section id={id} className="mon-hero-root mon-hero-desktop" aria-label="Join us hero">
      <div className="mon-hero-wrap">
        <div className="mon-hero-left">
          <p className="mon-hero-eyebrow">{data.eyebrow}</p>
          <h1 className="mon-hero-title">
            {data.titleLine1}<br />{data.titleLine2}
          </h1>
          <p className="mon-hero-desc">{data.desc}</p>

          <div className="mon-hero-cta">
            <button className="mon-hero-btn" onClick={onPublisher}>
              <span>{data.ctaPublisher.toUpperCase()}</span>
            </button>
            <button className="mon-hero-btn mon-hero-btn--ghost" onClick={onAdvertiser}>
              <span>{data.ctaAdvertiser.toUpperCase()}</span>
            </button>
          </div>
        </div>

        <div className="mon-hero-right">
          <img src={imageSrc} alt={data.imageAlt} loading="lazy" />
        </div>
      </div>
    </section>
  );
}
